import axios from "axios";
import { apiCall_domain } from "../api";
import toast from "react-hot-toast";
import SimpleReactValidator from "simple-react-validator";
import React from "react";
import Header from "../header";
import Spinner from "react-bootstrap/Spinner";
import { withRouter } from "routerCompat";
import { PulseLoader } from "react-spinners";

class ReportProblem extends React.Component {
  constructor() {
    super();
    this.state = {
      text: "",
      title: "",
      image: "",
      uploadedImage: "",
      loading: false,
    };
    this.validator = new SimpleReactValidator({
      element: (message) => <p className={"error"}>{message}</p>,
      messages: {
        required: "این فیلد نمی تواند خالی باشد",
      },
      autoForceUpdate: this,
    });
  }
  changeTitle = (e) => {
    this.setState({ title: e.target.value });
  };

  uploadFile = (file) => {
    let formData = new FormData();
    formData.append("file", file);
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
    };
    return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
      headers: headers,
    });
  };

  changeText = (e) => {
    this.setState({ text: e.target.value });
  };
  onImageChange = (img) => {
    this.setState({ showPic: URL.createObjectURL(img) });
  };
  changeImage = (e) => {
    this.onImageChange(e.target.files[0]);
    this.setState({ pic: e.target.files[0] });
  };
  changeLoader = (loading) => {
    this.setState({ loading });
  };
  handleError = (message) => {
    this.changeLoader(false);
    toast.error(message);
  };
  handleSuccess = () => {
    this.changeLoader(false);
    toast.success("جواب شما با موفقیت ارسال شد");
  };
  sendTicket = (pic = null) => {
    const data = {
      title: this.state.title,
      text: this.state.text,
      vendor_id: this.props.match.params.vendor_id,
      item_vendor_id: this.props.match.params.item_vendor_id,
      pic,
    };

    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .post(`${apiCall_domain}/customer/user/tickets`, data, { headers })
      .then((res) => {
        this.handleSuccess();
      })
      .catch((err) => {
        this.handleError(err?.response?.data?.message);
      });
  };
  submit = (e) => {
    e.preventDefault();
    this.validator.showMessages();
    if (this.validator.allValid() && this.state.loading === false) {
      this.changeLoader(true);
      const id = this.props.vendorId;
      if (this.state.pic) {
        this.uploadFile(this.state.pic).then((res) => {
          if (res.data.success) {
            this.sendTicket(res.data.name);
          } else {
            this.handleError("ارسال تیکت با خطا مواجه شد");
          }
        });
      } else {
        this.sendTicket();
      }
    }
  };

  // searchProduct = (data) => {
  //   let tempProducts = [];
  //   this.props.products.map((product) => {});
  // };
  render() {
    return (
      <div className={`newTicket noMargin`}>
        <Header
          showSearchBar={true}
          title={`ثبت مشکل`}
          backUrl={`orderDetails/${this.props.match.params.id}`}
        />
        <div className={"content"}>
          <form>
            <div className={"formGroup"}>
              <label>موضوع تیکت خود را برای فروشنده بنویسید</label>
              <input
                placeholder="عنوان خود را وارد کنید"
                type="text"
                value={this.state.title}
                onChange={this.changeTitle}
              />
              {this.validator.message("title", this.state.title, "required")}
            </div>
            {/* <div className={styles.formGroup}>
                <label>نام محصول مورد نظر را بنویسید</label>
                <input
                  placeholder='عنوان خود را وارد کنید'
                  type='text'
                  value={this.state.title}
                  onChange={this.changeTitle}
                />
                {this.validator.message("title", this.state.title, "required")}
              </div> */}
            <div className={"formGroup"}>
              <label>متن پیام</label>
              <textarea
                value={this.state.text}
                onChange={this.changeText}
                placeholder="متن پیام خودرا بنویسید"
              ></textarea>
              {this.validator.message("text", this.state.text, "required")}
            </div>
            <div className={"addImage"}>
              {this.state.showPic ? (
                <img className={"showPic"} src={this.state.showPic} />
              ) : (
                <>
                  <i className="icon-upload" />
                  <span>افزودن عکس </span>
                </>
              )}
              <input
                type="file"
                onChange={this.changeImage}
                accept="pic/png, pic/gif, pic/jpeg"
              />
            </div>
            <button onClick={this.submit}>
              {this.state.loading ? (
                <PulseLoader size={14} color="#fff" loading={true} />
              ) : (
                "ارسال تیکت"
              )}
            </button>
          </form>
        </div>
      </div>
    );
  }
}
export default withRouter(ReportProblem);
